module.exports = __webpack_public_path__ + "static/media/isprogressing.1d7626e6.gif";